import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelCatChristmas: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" height="170" width="255" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="m32.54 115.373 75.5 39.7v2.73l132.64-25.15v-2.73l-75.5-39.7-132.64 25.15Z" fill="#BB9260" />
    <path
      d="m76.91 163.683 31.09-5.88-75.5-39.7-30.5 5.82 74.91 39.76Z"
      fill="url(#parcel_cat_christmas_paint0_linear)"
    />
    <path
      d="m238.61 128.803-3.94-2-133 25-3.43-1.81 133-25-3.88-2-133 25-3.43-1.8 133-25-3.89-2-133 25-3.43-1.8 133-25-3.88-2-133 25-3.43-1.81 133-25-3.88-2.05-133 25-3.42-2.04 133-25-3.88-2-133 25-3.44-1.8 133-25-3.88-2-133 25-3.43-1.8 133-25-3.88-2-133 25-3.49-1.9 133-25-3.89-2-133 25-3.44-1.81 133-25-3.89-2-133 25-3.3-1.73v2.73l47.22 24.83 7.23 3.8v.06h.08l7.17 3.78v.09h.12l13.7 7.06v-2.73l-2.47-1.3 133.08-24.97Z"
      fill="#9E7548"
    />
    <path
      d="m95.23 140.653 27.18-5.22-29.85-15.76-27.35 5.13 30.02 15.85Z"
      fill="url(#parcel_cat_christmas_paint1_linear)"
    />
    <path
      opacity=".5"
      d="m103.16 140.493 18.43-3.69-31.33-15.51-18.44 3.5 31.34 15.7Z"
      fill="url(#parcel_cat_christmas_paint2_linear)"
    />
    <path d="m121.59 87.383 54.92-10-31.33-15.43-54.92 9.76 31.33 15.67Z" fill="#FDDE84" />
    <path opacity=".4" d="m108.13 80.563 54.93-9.77-5.16-2.58-55.11 9.77 5.34 2.58Z" fill="#AA7B33" />
    <path d="M121.59 87.383v49.39l-31.33-15.48v-49.58l31.33 15.67Z" fill="#C39000" />
    <path opacity=".4" d="M108.13 80.563v10.87l-5.34-2.76v-10.69l5.34 2.58Z" fill="#AA7B33" />
    <path d="M121.59 87.383v49.39l54.92-10v-49.34l-54.92 9.95Z" fill="#FCCE09" />
    <path d="m108.13 130.143-4.79-2.4-.55-49.76 5.34 2.58v49.58Z" fill="#7F0522" />
    <path d="m157.9 68.213-55.11 9.77 5.34 2.58 54.93-9.77-5.16-2.58Z" fill="#A30323" />
    <path d="m145.92 132.353 5.71-.92.37-49.58-6.08 1.11v49.39Z" fill="#AF0527" />
    <path d="m122 66.003 30 15.85-6.08 1.11-29.49-15.85 5.57-1.11Z" fill="#D2002E" />
    <path
      d="m130.07 73.373-14.56-.88c-3.14-.18-4.43 1.48-4.43 3.32 0 1.66 1.48 3 3 3.68 1.48.93 7.93 5.17 7.93 5.17l12.53-8.3-4.47-2.99Z"
      fill="#D2002E"
    />
    <path
      d="M134.49 76.143s-5.71 1.1-8.66 1.84c-3 .55-5.72 1.29-5.16 4.61.56 3.32 4.24 2 6.26.55 1.66-1.84 7.56-7 7.56-7Z"
      fill="#AF0527"
    />
    <path
      d="M131.54 73.193s3.32-8.7 4.06-10.7c.74-2 2.21-4.24 4.23-3.32 2.02.92 11.06 5.71 11.06 5.71l-15.29 10.89-4.06-2.58Z"
      fill="#D2002E"
    />
    <path
      d="M135.41 75.773s8.66-8.11 10-9.22c1.34-1.11 5.53-3.5 5.72-.73.19 2.77-2 3.68-4.61 5.16-2.63 1.29-11.11 4.79-11.11 4.79ZM117 73.373l13.45.56 1.48 1.84-9.4 2 6.82-2.22-4.42-.18 3.5-.74-11.43-1.26ZM133 72.643l3.68-8.67-2.39 7.74 1.65-2-.73 2.21s2.58-3.32 2.58-3.14l-1.79 3.71 7.19-5.9-7.92 7.38-2.27-1.33Z"
      fill="#AF0527"
    />
    <path
      d="M135.6 73.003c1.47.74 1.47 2.22 0 3a6.301 6.301 0 0 1-5.17 0c-1.47-.73-1.47-2.21 0-3a5.18 5.18 0 0 1 5.17 0Z"
      fill="#D2002E"
    />
    <path
      d="M136 75.403a6.269 6.269 0 0 1-5.16 0c-.92-.55-1.29-1.29-.92-2-.74.74-.55 1.85.55 2.58a6.301 6.301 0 0 0 5.17 0 1.517 1.517 0 0 0 .92-.92c-.04.16-.23.16-.56.34Z"
      fill="#AF0527"
    />
    <path opacity=".05" d="M112.56 77.613v1.48l12.53-1.85v-1.66l-12.53 2.03Z" fill="#000" />
    <path d="m122.4 73.783 52.65-10-30-15.76-52.65 10 30 15.76Z" fill="#926607" />
    <path
      d="m167.38 76.603-7.28-6.47-10.1-3.19-59.3 1.55 23 33.4"
      fill="url(#parcel_cat_christmas_paint3_linear)"
      fillOpacity=".6"
    />
    <path d="M150.4 111.703v13.47l22-4.18v-13.5l-22 4.21Z" fill="#fff" />
    <path
      d="m155.74 121.503-3.26.6v-8.03l3.26-.61v8.04ZM160.98 120.543l-1.63.29v-8.03l1.63-.3v8.04ZM166.94 119.423l-3.86.72v-8.03l3.86-.73v8.04ZM170.31 118.793l-1.63.31v-8.04l1.63-.3v8.03ZM158.16 121.063l-.66.12v-8.04l.66-.12v8.04Z"
      fill="#000"
    />
    <path
      d="M177.86 69.493c3.07 3.89-.92 7.89-6.35 10.86-5.43 2.97-12.09 2.87-13.63 0-.92-1.74.1-4.31 2.05-6.25 2.56-2.67 5.43-3.28 7.58-4.72 2-1.33 3.38-2.76 4.71-3 2.26-.6 4.1.94 5.64 3.11ZM142.31 26.233l6.86 47.64-20.49 2.56a9.205 9.205 0 0 1-1.74.11c-6.66.3-6.66.3-7.58.41-4.3.1-8.81-.11-12.5-.11l-4.92-.51c-2.56-.41-5.84-.82-7.78-2.46-1.74-1.38-2.67-5.12-3.59-7.38-3.69-9.43-3.07-20.08.51-29.61.21-.51.41-1 .62-1.64a24.27 24.27 0 0 1 19-15.47h.31a24.57 24.57 0 0 1 16.19 2.87l.51.31c2.15 1.22 4.2 2.76 6.56 3.27 2.61.63 5.48.27 8.04.01Z"
      fill="#C8C9C8"
    />
    <path
      d="M108.19 68.343a12 12 0 0 0-7.07.51c-4 1.64-7.78 4.92-7 5.53 1.94 1.64 5.12 2 7.78 2.46l4.92.51c3.69 0 8.2.21 12.5.11.92 0 .92 0 7.48-.41.61 0 1.13-.1 1.74-.1l15.57-.93 10.15-1.64 3.21-3.89-12.4 3.28.52 1.54-13.32-17.32-5 6.46a32.704 32.704 0 0 1-8 5.43c-1.85.71-4 1-7.58-.52a9.563 9.563 0 0 0-1.54-.51l-1.96-.51ZM174.68 66.703c.62 1.13-4.51 5-7.89 8.5-3.17 3.28-6.76 2.46-7.58.62-.82-1.84.92-3.28 5.33-5.23 5.22-2.25 9.46-5.22 10.14-3.89Z"
      fill="#B8B8B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.55 20.593a24.74 24.74 0 0 0-11.49-.81h-.31a24.267 24.267 0 0 0-18.69 14.55c.58 4.57 5.3 7.68 11.93 6.34 11.01-2.18 17.4-16.36 18.56-20.08Z"
      fill="#B8B8B8"
    />
    <path
      d="M115.26 62.713c4.53 0 8.2-3 8.2-6.77 0-3.77-3.67-6.76-8.2-6.76-4.53 0-8.19 3-8.19 6.76s3.67 6.77 8.19 6.77ZM173.86 34.023l-.41-9.22c.31-.21.93-.31.93 1.74l-.52 7.48ZM146.2 30.333l2.25-1.54-3.79-4.09c-1.12-.93-1.84-.21-1.84-.21a2.592 2.592 0 0 1 2.25 2.15c.05.246.12.487.21.72l.92 2.97Z"
      fill="#B8B8B8"
    />
    <path
      d="M92 59.083s-14.14 4.2-15 18.65c0 0-1.13 14 17.41 16.9 0 0 18.34 4.1 19.78-5.33 0 0 1.12-11-6.87-9-3.28.51-9.32.82-11.88-.41 0 0-3.89-2.77.82-7.48L92 59.083Z"
      fill="#C8C9C8"
    />
    <path
      d="M99.68 69.633s-12.19 1.23-9.83 8.2c0 0 1 2.56 7.37 2.66a5.43 5.43 0 0 1-2.15-.92c-.92-.92-2.15-3.18.51-6.45a29.546 29.546 0 0 1 4.1-3.49Z"
      fill="#B8B8B8"
    />
    <path
      d="M152.42 79.263c.69-3.26-3.72-7-9.86-8.28-6.14-1.28-11.69.28-12.39 3.55-.7 3.27 3.73 7 9.87 8.27 6.14 1.27 11.68-.31 12.38-3.54Z"
      fill="#C8C9C8"
    />
    <path
      d="M151.73 77.493c-.71 1.74-4.61 2-7.78-1-2.87-2.76-4.72-5-4.41-5.73.1-.21 2.15-.72 6.25 1a16.375 16.375 0 0 1 3.28 1.73c1.93 1.61 3.18 2.74 2.66 4Z"
      fill="#B8B8B8"
    />
    <path d="m175.3 37.813-8-8 6.7-7.78c1.75-1.12 2.16.51 2.16 3.18l-.86 12.6Z" fill="#E4E4E4" />
    <path d="m173.86 34.023-4.4-4.71 3.58-4.2c.82-.72 1.33-.62 1.33 1.43l-.51 7.48Z" fill="#C8C8C8" />
    <path
      d="M155.52 74.493c14.09 0 25.48-11.75 25.48-26.23s-11.39-26.23-25.48-26.23S130 33.783 130 48.263s11.44 26.23 25.52 26.23Z"
      fill="#E4E4E4"
    />
    <path d="m140.26 33.923 9.53-5.95-5.74-6.24c-1.74-1.54-3.48-.72-3.69 1.63l-.1 10.56Z" fill="#E4E4E4" />
    <path
      d="m142.21 32.693 6.25-3.9-3.8-4.09c-1.12-.93-2.25-.41-2.35 1l-.1 6.99ZM175.23 36.883c1.61-3.25-1-7.83-5.91-10.24s-10.12-1.72-11.72 1.53c-1.6 3.25 1 7.82 5.91 10.23s10.12 1.72 11.72-1.52ZM168.54 53.493c.3 0 .61-.1.82-.1h1.94c.41 0 .82.1 1.23.1.41 0 .72.11 1 .21l1 .2.1-.41-1-.2c-.31-.1-.72-.1-1-.2h-.2c-.31 0-.72-.11-1-.11h-1.94c-.41 0-.82.11-1.23.11l-.72.1a2.999 2.999 0 0 0-.92.2l-.31.1a6.603 6.603 0 0 0-1.23.41l-.41.21.11.2v.18h1.43c.621.05 1.237.154 1.84.31.41.1.72.1 1.13.2l.41.1 1.84.62h.11c.633.227 1.248.502 1.84.82l.72.41.2-.41-.92-.51c-.51-.21-1-.52-1.54-.72l-.41-.21-1.87-.61-.31-.1c-.41-.11-.92-.21-1.33-.31l-.72-.1-.92-.11.82-.3 1.44-.08ZM153 53.893c-.3 0-.61-.1-.82-.1h-1.98c-.41 0-.82.1-1.23.1-.41 0-.72.11-1 .21l-2.05.72-.2-.41 2.15-.72c.31-.1.72-.1 1-.21h.2c.31 0 .72-.1 1-.1H152c.41 0 .82.1 1.23.1l.72.11c.315.018.626.086.92.2l.31.1c.422.096.834.233 1.23.41l.41.21-.11.2v.21h-1.43c-.621.05-1.237.154-1.84.31-.41.1-.72.1-1.13.2l-.41.1-1.85.62H150c-.633.227-1.248.502-1.84.82l-.82.51-.21-.41 1-.61c.51-.21 1-.52 1.54-.72l.4-.21 1.85-.61.31-.1c.41-.11.92-.21 1.33-.31l.72-.1.92-.11-.82-.3-1.38-.11Z"
      fill="#C8C8C8"
    />
    <path
      d="M168.53 55.743c-.2-.1-.4 0-.4.2a3.796 3.796 0 0 1-3.337 2.336 3.797 3.797 0 0 1-3.533-2.026.102.102 0 0 1-.071-.029.103.103 0 0 1-.029-.07.103.103 0 0 0-.029-.071.1.1 0 0 0-.071-.03h-.21a.1.1 0 0 1-.1.1.102.102 0 0 0-.071.03.103.103 0 0 0-.029.07c0 .1-.62 1.74-3.08 2.25a3.998 3.998 0 0 1-4.57-1.94c-.1-.21-.3-.21-.51-.1-.21.11-.2.3-.1.51a4.82 4.82 0 0 0 4.1 2.35c.413.017.826-.017 1.23-.1a4.941 4.941 0 0 0 3.38-2.15 4.274 4.274 0 0 0 3.48 2c.337.017.675-.02 1-.11a4.002 4.002 0 0 0 3.28-2.76.542.542 0 0 0-.33-.46Z"
      fill="#8E8E8E"
    />
    <path d="M157.47 52.563H164l-3 3.69" fill="#D20612" />
    <path
      d="M152 47.033a1.639 1.639 0 0 1-1.64 1.74 1.711 1.711 0 0 1-1.64-1.74 1.642 1.642 0 0 1 1.64-1.64 1.641 1.641 0 0 1 1.64 1.64ZM170.58 47.033a1.64 1.64 0 0 1-1.64 1.74 1.699 1.699 0 0 1-1.63-1.74 1.631 1.631 0 0 1 .978-1.63 1.64 1.64 0 0 1 2.292 1.63Z"
      fill="#000"
    />
    <path
      d="m168.84 24.703-1.64-2.38c-1.1-1.6-6.06-4.33-6.06-4.33-12.63-5.12-22.74-2.12-24.63-2.12l3 1c-2.41 0 6.84.42 4.58 1.25l-3.51 1.29a24.453 24.453 0 0 0-7.58 4.45l-1 .89a13.19 13.19 0 0 0-3.66 5.13v.1a10.571 10.571 0 0 0-.76 3.92v.49c0 1.404.11 2.804.33 4.19l.67 4.29 40.26-18.17Z"
      fill="#D20612"
    />
    <path
      d="m126.51 56.873-3.7 12.77-2.24 7.24a3.33 3.33 0 0 1-6.34.08 3.367 3.367 0 0 1-.15-.61l-1.36-9.92a88.289 88.289 0 0 1-.33-21.18 43.24 43.24 0 0 1 4.26-14.66v-.1a30.87 30.87 0 0 1 10.96-12.26l.47-.3 1-.5.45-.16a33.702 33.702 0 0 1 13.72-1.92l4.24.29 1 .18 8.13 2.34.55.2 9.71 4.13a1.597 1.597 0 0 1 .895 1.43 1.592 1.592 0 0 1-.895 1.43l-1.58.76-.27.14-13.26 7.34-.68.46-16.58 8.82c-.12.08-3.88.91-4 1-.2.13-.88-.22-1 0"
      fill="#D40511"
    />
    <path
      d="m167.895 23.681-39.208 16.554a1.41 1.41 0 0 0-.751 1.848l1.089 2.58a1.41 1.41 0 0 0 1.848.75l39.208-16.555a1.41 1.41 0 0 0 .751-1.847l-1.089-2.58a1.41 1.41 0 0 0-1.848-.75Z"
      fill="#fff"
    />
    <path
      d="m168.3 25.493-.13.1-.63.58a1.67 1.67 0 0 1-.54.32l-5.43 1.75a.852.852 0 0 0-.26.11l-7.4 4.08c-.15.079-.313.133-.48.16l-2.92.43-.23.05-4.38 1.42c-.141.042-.273.11-.39.2l-1.85 1.33a1.826 1.826 0 0 1-.31.16l-6.7 2.64-.27.14-2.67 1.78c-.131.09-.276.158-.43.2l-2.72.71.36.46a1.422 1.422 0 0 0 1.52.5l9.7-2.74.13-.05 9-3.53h.09l9.15-4.35h.08l6.12-2.49 4.28-1.8v-.19l-.15-.49-.35-.81a1.427 1.427 0 0 0-1.584-.926 1.429 1.429 0 0 0-.606.256Z"
      fill="#EBEBEC"
    />
    <path
      d="M130.56 41.643a4.147 4.147 0 0 0 1.77.39 4.13 4.13 0 0 0 2.17-.61l.37-.22a4.59 4.59 0 0 1 .74-.36l2.07-.75a4.1 4.1 0 0 1 1.43-.25h.95a4.13 4.13 0 0 0 2.27-.67l1.77-1.15 3.38-2a4.141 4.141 0 0 1 2.11-.58h.84a4.218 4.218 0 0 0 2.26-.68l2.91-1.89a3.93 3.93 0 0 1 1.16-.53l1.75-.48 4.27-1.4c.286-.094.56-.218.82-.37l2.26-1.33a4 4 0 0 1 1.1-.46l1-.26.45-.14 2.39-.9.11.55-.1.51-.37.54-1.81.85L145 39.493l-14.14 6-.6.11-.5-.11-.46-.31-.29-.44-.53-1.24-.56-1.33"
      fill="#EBEBEC"
    />
    <path
      opacity=".4"
      d="m128.7 40.233-1.19.76-1-3.12a10.503 10.503 0 0 1-1.18-7.07l.43-2.34.39-1a9.606 9.606 0 0 1 2.85-3.8l.58-.47a1.71 1.71 0 0 1 1.17-.37 1.062 1.062 0 0 1 1 .78l.6 2.21a3.772 3.772 0 0 1-.48 3l-1.76 2.68a2.999 2.999 0 0 0-.4 2.25l.15.63c.1.458.329.878.66 1.21l2.72 2.75-4.54 1.9Z"
      fill="#90191C"
    />
    <path
      opacity=".4"
      d="m122.81 69.633 2.61-9.01 2.09-6.22 1.52-9.74-1.89-4.82-1.22-3.21-5.72 40.58 2.61-7.58Z"
      fill="#90191C"
    />
    <path
      d="M122.28 79.123a4.761 4.761 0 0 1-9.393 1.367 4.756 4.756 0 0 1 1.965-4.982 4.763 4.763 0 0 1 2.678-.825 4.52 4.52 0 0 1 4.75 4.44Z"
      fill="#EBEBEC"
    />
    <path
      d="M122 77.493a4.75 4.75 0 0 0-4.45-2.85 4.91 4.91 0 0 0-4.75 4.12c.6-.63 1.49-1 1.78-.63.29.37.6-.64 1.19-1a5.76 5.76 0 0 1 2.38 0 1.469 1.469 0 0 1 2.07 0c.581.173 1.177.294 1.78.36Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="parcel_cat_christmas_paint0_linear"
        x1="49.74"
        y1="150.983"
        x2="62.35"
        y2="126.813"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".6" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_christmas_paint1_linear"
        x1="90.26"
        y1="136.923"
        x2="102.59"
        y2="113.373"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9E7549" stopOpacity="0" />
        <stop offset=".5" stopColor="#4F3A24" stopOpacity=".5" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_christmas_paint2_linear"
        x1="93.98"
        y1="136.123"
        x2="99.42"
        y2="125.463"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".51" stopColor="#181816" stopOpacity=".36" />
        <stop offset=".82" stopColor="#080807" stopOpacity=".82" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="parcel_cat_christmas_paint3_linear"
        x1="115.26"
        y1="100.283"
        x2="143.91"
        y2="42.603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCCE09" stopOpacity="0" />
        <stop offset=".5" stopColor="#7E6705" stopOpacity=".5" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
